import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Lead_Creation } from "../../../Configuration/API_URL";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  onlyNumber,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useWatch } from "react-hook-form";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function PersonalDetails(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const resumeVal = props?.resumeVal;
  const masterValue = props?.masterValue;
  const mobNum = resumeVal?.verificationDetails?.mobileNo;
  const [pincodeVal, setPincodeVal] = useState("");
  const [permaPincodeVal, setPermaPincodeVal] = useState("");
  const { resumeHandle } = useResumeContext();
  const [presentCity, setPresentCity] = useState("");
  const [presentState, setPresentState] = useState("");
  const [permaCity, setPermaCity] = useState("");
  const [permaState, setPermaState] = useState("");
  const [isDetailsSaved, setIsDetailsSaved] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [permaCityOptions, setPermaCityOptions] = useState([]);
  const showNom = props.showNom;
  const [loader, setLoader] = useState(false);
  const initialSnapshot = useRef({});
  const requiredFields = [
    "fNameValid",
    "genderValid",
    "marritalStatValid",
    "incomeRange",
    "occupationValid",
    "bussinessTypeVal",
    "ddpiValid",
    "fnoValid",
    "nationality",
    "residenAdd",
    "accType",
    "tradingPref",
    "presentAdd",
    "presentAdd2",
    "pinCodeValid",
    "cityValid",
    "stateValid",
    "permanentAdd",
    "permanAdd1",
    "permanAdd2",
    "permaPinCodeValid",
    "permaCityValid",
    "permaStateValid",
    "nomineeDetails",
    "netWorth",
    "tradingExper",
    "politicallyExpo",
    "pastActions",
  ];
  const activeTab = props?.activeTab;
  const { selectedClient, shouldPrefill } = useClientContext();

  const errorSchema = Yup.object().shape({
    fNameValid: Yup.string().required("Father name is required"),
    genderValid: Yup.string().required("Gender is required"),
    marritalStatValid: Yup.string().required("Marrital status is required"),
    incomeRange: Yup.string().required("Income range is required"),
    occupationValid: Yup.string().required("Occupation is required"),
    bussinessTypeVal: Yup.string().required("Business type is required"),
    ddpiValid: Yup.string().required("DDPI is required"),
    fnoValid: Yup.string().required("F&O status is required"),
    // nationality: Yup.string().required("Nationality is required"),
    // residenAdd: Yup.string().required("Residential status is required"),
    accType: Yup.string().required("Account type is required"),
    tradingPref: Yup.string().required("Trading preference is required"),
    presentAdd: Yup.string().required("Address is required"),
    presentAdd2: Yup.string(),
    pinCodeValid: Yup.string().required("Pincode is required").length(6, "Pincode must be 6 digits"),
    cityValid: Yup.string().test(
      "cityValid",
      "City is required",
      function (value) {
        const { path, createError, options } = this;
        const presentCity = options.context?.presentCity;
        return value?.trim()?.length > 0 || presentCity?.trim()?.length > 0
      ? true
      : createError({ path, message: "City is required" });
  }
      //   return cityOptions?.length > 0 ||
      //     value ||
      //     presentCity?.trim()?.length > 0
      //     ? true
      //     : createError({ path, message: "City is required" });
      // }
    ),
    stateValid: Yup.string().test(
      "stateValid",
      "State is required",
      function (value) {
        const { path, createError } = this;
        return value || presentState?.length > 0
          ? true
          : createError({ path, message: "State is required" });
      }
    ),
    permanentAdd: Yup.string().required("Permanent address type is required"),
    permanAdd1: Yup.string().required("Permanent address is required"),
    permanAdd2: Yup.string(),
    permaPinCodeValid: Yup.string().required("Pincode is required"),
    permaCityValid: Yup.string().test(
      "permaCityValid",
      "City is required",
      function (value) {
        const { path, createError, options } = this;
        const permaCity = options.context?.permaCity;
         return value?.trim()?.length > 0 || permaCity?.trim()?.length > 0
      ? true
      : createError({ path, message: "City is required" });
  }
        
      //   return permaCityOptions?.length > 0 ||
      //     value ||
      //     permaCity?.trim()?.length > 0
      //     ? true
      //     : createError({ path, message: "City is required" });
      // }
    ),
    permaStateValid: Yup.string().test(
      "permaStateValid",
      "State is required",
      function (value) {
        const { path, createError } = this;
        return value || permaState?.length > 0
          ? true
          : createError({ path, message: "State is required" });
      }
    ),
    nomineeDetails: Yup.string().required("Nominee is required"),
    // netWorth: Yup.string().required("Networth details are required"),
    tradingExper: Yup.string().required("Trading experience is required"),
    politicallyExpo: Yup.string().required(
      "Politically exposed status is required"
    ),
    // pastActions: Yup.string().required("Past action status is required"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    setError,
    clearErrors,
    trigger,
    reset: resetForm,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const watchedFields = watch();
  const permanentAdd = watch("permanentAdd");
  const presentAdd = watch("presentAdd");
  const presentAdd2 = watch("presentAdd2");
  const pinCodeValid = watch("pinCodeValid");
  const cityValid = watch("cityValid");
  const stateValid = watch("stateValid");
  // const pastActionDetails = watch("pastActions");
  const nomineeDetails = watch("nomineeDetails");

  const prevPermanentAddRef = useRef(permanentAdd);

  useEffect(() => {
    if (permanentAdd === "Same as Present Address") {
      if (pinCodeValid?.length < 6) {
        setValue("permaPinCodeValid", "");
        setValue("permaCityValid", "");
        setValue("permaStateValid", "");
        setPermaPincodeVal("");
        setPermaCity("");
        setPermaState("");
        setPermaCityOptions([]);
      } else {
        setValue("permanAdd1", presentAdd);
        setValue("permanAdd2", presentAdd2);
        setValue("permaPinCodeValid", pinCodeValid);
        setValue("permaCityValid", presentCity ? presentCity : cityValid);
        setValue("permaStateValid", presentState ? presentState : stateValid);
        setPermaPincodeVal(pinCodeValid);
        setPermaCity(presentCity ? presentCity : cityValid);
        setPermaState(presentState ? presentState : stateValid);
        setPermaCityOptions([]);
        clearErrors(["permanAdd1", "permaPinCodeValid", "permaCityValid", "permaStateValid"])
      }
    }
    if (
      prevPermanentAddRef.current === "Same as Present Address" &&
      permanentAdd === "Enter Manually"
    ) {
      setValue("permanAdd1", "");
      setValue("permanAdd2", "");
      setValue("permaPinCodeValid", "");
      setValue("permaCityValid", "");
      setValue("permaStateValid", "");
      setPermaPincodeVal("");
      setPermaCity("");
      setPermaState("");
      setPermaCityOptions([]);
    }
    prevPermanentAddRef.current = permanentAdd;
    // if (
    //   permanentAdd === "Enter Manually" &&
    //   pinCodeValid !== "" &&
    //   (cityValid !== "" || presentCity !== "") &&
    //   (stateValid !== "" || presentState !== "")
    // ) {
    //   setValue("permanAdd1", "");
    //   setValue("permanAdd2", "");
    //   setValue("permaPinCodeValid", "");
    //   setValue("permaCityValid", "");
    //   setValue("permaStateValid", "");
    //   setPermaPincodeVal("");
    //   setPermaCity("");
    //   setPermaState("");
    // }
  }, [
    permanentAdd,
    permaPincodeVal,
    pinCodeValid,
    presentAdd,
    presentAdd2,
    cityValid,
    stateValid,
    presentCity,
    presentState,
  ]);

  const PersonalDetailsData = async (data) => {
    setLoader(true);
    let payloadValue = {
      refId: resumeVal?.id,
      mobileNo: mobNum,
      fatherName: data?.fNameValid,
      gender: data?.genderValid.toUpperCase(),
      maritalStatus:
        data?.marritalStatValid.toUpperCase() === "UNMARRIED"
          ? "SINGLE"
          : data?.marritalStatValid.toUpperCase(),
      incomeRange: data?.incomeRange,
      occupation: data?.occupationValid,
      bussinessType: data?.bussinessTypeVal,
      optForDDPI: data?.ddpiValid === "Yes" ? true : false,
      activateFNO: data?.fnoValid === "Yes" ? true : false,
      nationality: "INDIAN",
      residentialStatus: "INDIAN",
      typeOfAccount: data?.accType,
      tradingPreferences: data?.tradingPref,
      isPermanentAddrIsSameAsPresentAddr:
        data?.permanentAdd === "Same as Present Address" ? true : false,
      presentAddressLine1: data?.presentAdd,
      presentAddressLine2: data?.presentAdd2,
      presentAddressPinCode:
        pincodeVal?.length === 6 ? pincodeVal : data?.pinCodeValid,
      presentAddressCity:
        presentCity?.length > 0 ? presentCity : data?.cityValid,
      presentAddressState:
        presentState?.length > 0 ? presentState : data?.stateValid,
      permanentAddressLine1: data?.permanAdd1,
      permanentAddressLine2: data?.permanAdd2,
      permanentAddressPinCode:
        permaPincodeVal?.length === 6
          ? permaPincodeVal
          : data?.permaPinCodeValid,
      permanentAddressCity:
        permaCity?.length > 0 ? permaCity : data?.permaCityValid,
      permanentAddressState:
        permaState?.length > 0 ? permaState : data?.permaStateValid,
      addNomineeDetails: data?.nomineeDetails === "Yes" ? true : false,
      netWorth: data?.netWorth,
      tradingExperience: data?.tradingExper,
      isPoliticallyExposed: data?.politicallyExpo === "Yes" ? true : false,
      pastActions: "No"
      // pastActions: data?.pastActions
    };
    
    console.log(payloadValue, "payloadValueInsert");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.Personal_Details,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      
      if (res?.status === 0) {
        resumeHandle();
        toast.success(res?.data);
        // setFormSaved(true);
        const currentValues = getValues();
        resetForm(currentValues);
        initialSnapshot.current = currentValues;
        setIsDetailsSaved(true);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      
    }
  };

  const finalSubmit = (data) => {
    console.log(data, "dataInsert");
    
    if (IndiMobileNo !== null || mobNum !== "") {
      PersonalDetailsData(data);
    }
  };

  const handlePincodeChange = (e, type) => {
    const pin = e?.target?.value;
    if (pin?.length === 6) {
      if (type === "present") {
        getStateCity(pin);
        clearErrors(["cityValid", "stateValid"]);
      } else if (type === "permanent") {
        getPermanentStateCity(pin);
        clearErrors(["permaCityValid", "permaStateValid"]);
      }
    } else {
      if (type === "present") {
        setValue("cityValid", "");
        setValue("stateValid", "");
        setPresentCity("");
        setPresentState("");
        setCityOptions([]);
        setError("cityValid", { type: "manual", message: "City is required" });
      setError("stateValid", { type: "manual", message: "State is required" });
      } else if (type === "permanent") {
        setValue("permaCityValid", "");
        setValue("permaStateValid", "");
        setPermaCity("");
        setPermaState("");
        setPermaCityOptions([]);
        setError("permaCityValid", {
        type: "manual",
        message: "City is required",
      });
      setError("permaStateValid", {
        type: "manual",
        message: "State is required",
      });
      }
    }
  };
  
  const getStateCity = async (pincode) => {
    setPincodeVal(pincode);

    let payloadValue = {
      pincode: pincode,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.pincode_Details,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getRelation?.data);
      setValue("cityValid", "");
      setValue("stateValid", "");

      if (res?.status === 0) {
        const pinResp = res?.data || [];
        setCityOptions(pinResp);

        if (pinResp?.length === 1) {
          setPresentCity(pinResp[0].city);
          setPresentState(pinResp[0].state);
          setValue("cityValid", pinResp[0].city);
          setValue("stateValid", pinResp[0].state);
          if (permanentAdd === "Same as Present Address") {
            setValue("permaCityValid", pinResp[0].city);
            setValue("permaStateValid", pinResp[0].state);
          }
        } else {
          setPresentState(pinResp[0]?.state);
        }
      } else {
        setValue("cityValid", "");
        setValue("stateValid", "");
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPermanentStateCity = async (pincode) => {
    setPermaPincodeVal(pincode);

    let payloadValue = {
      pincode: pincode,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.pincode_Details,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getRelation?.data);
      setValue("permaCityValid", "");
      setValue("permaStateValid", "");

      if (res?.status === 0) {
        const pinResp = res?.data || [];
        setPermaCityOptions(pinResp);

        if (pinResp?.length === 1) {
          setPermaCity(pinResp[0].city);
          setPermaState(pinResp[0].state);
          setValue("permaCityValid", pinResp[0].city);
          setValue("permaStateValid", pinResp[0].state);
        } else {
          setPermaState(pinResp[0]?.state);
        }
      } else {
        setValue("permaCityValid", "");
        setValue("permaStateValid", "");
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const genderOptions = [
    { label: "Male", name: "MALE" },
    { label: "Female", name: "FEMALE" },
    { label: "Other", name: "OTHER" },
  ];
  const maritalOptions = [
    { label: "Unmarried", name: "UNMARRIED" },
    { label: "Married", name: "MARRIED" },
  ];

  const defaultOptions = [
    { label: "Yes", name: "Yes" },
    { label: "No", name: "No" },
  ];

  const permanentAddress = [
    { label: "Same as Present Address", name: "Same as Present Address" },
    { label: "Enter Manually", name: "Enter Manually" },
  ];

  const politicallyExposed = [
    { label: "Yes", name: "Yes" },
    { label: "No", name: "No" },
    { label: "Related to PEP", name: "Related to PEP" },
  ];

  const pastActions = [
    // { label: "Yes (If yes then specify)", name: "Yes (If yes then specify)" },
    { label: "No", name: "No" },
  ];

  console.log(activeTab, shouldPrefill, IndiMobileNo, selectedClient?.mobile, resumeVal?.personalDetails,  "activeTab");
  

  useEffect(() => {
    if (activeTab !== "individual") {
      resetForm({
        fNameValid: "",
        genderValid: "",
        marritalStatValid: "",
        incomeRange: "",
        occupationValid: "",
        bussinessTypeVal: "",
        ddpiValid: "",
        fnoValid: "",
        // nationality: "",
        // residenAdd: "",
        accType: "",
        tradingPref: "",
        presentAdd: "",
        presentAdd2: "",
        pinCodeValid: "",
        cityValid: "",
        stateValid: "",
        permanentAdd: "",
        permanAdd1: "",
        permanAdd2: "",
        permaPinCodeValid: "",
        permaCityValid: "",
        permaStateValid: "",
        nomineeDetails: "",
        // netWorth: 0,
        tradingExper: "",
        politicallyExpo: "",
        // pastActions: "",
      });
        setPresentCity("");
        setPresentState("");
        setPermaCity("");
        setPermaState("");
        setCityOptions([]);
        setPermaCityOptions([]);
        setPincodeVal("");
        setPermaPincodeVal("");
    } else if (
      shouldPrefill &&
      (selectedClient?.mobile || IndiMobileNo) &&
      resumeVal?.personalDetails
    ) {

      const details = resumeVal?.personalDetails;
      console.log(details, "detailsdetailsdetails");

      setValue("fNameValid", details?.fatherName || "");
      setValue("genderValid", details?.gender || "");
      setValue(
        "marritalStatValid",
        details?.maritalStatus === "SINGLE"
          ? "UNMARRIED"
          : details?.maritalStatus || ""
      );
      setValue("incomeRange", details?.incomeRange || "");
      setValue("occupationValid", details?.occupation || "");
      setValue("bussinessTypeVal", details?.bussinessType || "");
      setValue("ddpiValid", details?.optForDDPI === true ? "Yes" : "No" || "");
      setValue("fnoValid", details?.activateFNO === true ? "Yes" : "No" || "");
      setValue("nationality", details?.nationality);
      setValue("residenAdd", details?.residentialStatus);
      setValue("accType", details?.typeOfAccount || "");
      setValue("tradingPref", details?.tradingPreferences || "");
      setValue("presentAdd", details?.presentAddressLine1 || "");
      setValue("presentAdd2", details?.presentAddressLine2 || "");
      setValue("pinCodeValid", details?.presentAddressPinCode || "");
      setValue("cityValid", details?.presentAddressCity || "");
      setValue("stateValid", details?.presentAddressState || "");
      setValue(
        "permanentAdd",
        details?.isPermanentAddrIsSameAsPresentAddr === true
          ? "Same as Present Address"
          : details?.isPermanentAddrIsSameAsPresentAddr === false
          ? "Enter Manually"
          : details?.isPermanentAddrIsSameAsPresentAddr
      );
      setValue("permanAdd1", details?.permanentAddressLine1 || "");
      setValue("permanAdd2", details?.permanentAddressLine2 || "");
      setValue("permaPinCodeValid", details?.permanentAddressPinCode || "");
      setValue("permaCityValid", details?.permanentAddressCity || "");
      setValue("permaStateValid", details?.permanentAddressState || "");
      setValue(
        "nomineeDetails",
        details?.addNomineeDetails === true ? "Yes" : "No" || ""
      );
      setValue("netWorth", details?.netWorth);
      setValue("tradingExper", details?.tradingExperience || "");
      setValue(
        "politicallyExpo",
        details?.isPoliticallyExposed === true
          ? "Yes"
          : details?.isPoliticallyExposed === false
          ? "No"
          : details?.isPoliticallyExposed || ""
      );
      setValue(
        "pastActions",
        details?.pastActions);
    }
  }, [activeTab, shouldPrefill, selectedClient, resumeVal,]);

  useEffect(() => {
    if (
      !initialSnapshot.current ||
      Object.keys(initialSnapshot.current).length === 0
    )
      return;

    const hasChanged = requiredFields.some((field) => {
      const currentValue = watchedFields[field] || "";
      const initialValue = initialSnapshot.current[field] || "";
      return currentValue !== initialValue;
    });

    // setFormSaved(!hasChanged);
  }, [watchedFields]);

  console.log(resumeVal?.personalDetails, "personalDetails");
  

  useEffect(() => {
    if (resumeVal) {
      const values = getValues();
      initialSnapshot.current = values;
      if(resumeVal?.personalDetails?.addNomineeDetails === true){
          showNom(true)
        }else{
          showNom(false)
        }
    }
  }, [resumeVal]);

  useEffect(() => {
    const subscription = watch(() => {
      setIsDetailsSaved(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  const handlePasteInput = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.toUpperCase().replace(/[^A-Z\s]/g, "");
    clean = clean.replace(/\s+/g, " ").trim();
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 40);
    setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = start + clean.length;
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const handlePasteNational = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.toUpperCase().replace(/[^A-Z\s]/g, "");
    clean = clean.replace(/\s+/g, " ").trim();
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 25);

    setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = Math.min(start + clean.length, 25);
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const handlePasteAddress = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText
    .toUpperCase()
    .replace(/[^A-Z0-9#\/\-&.,\s]/g, "")
    .replace(/\s{2,}/g, " ")            
    .replace(/^\s+/, "")                
    .slice(0, 50);
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 50);
    setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = Math.min(start + clean.length, 50);
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const handlePastePincode = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/\D/g, "").trim().slice(0, 6);
    if (clean === "") return;
    setValue(fieldName, clean, { shouldValidate: true });
    e.target.value = clean;
  };

  useEffect(() => {
    if (presentCity || presentState) {
      setValue("cityValid", presentCity, { shouldValidate: true });
      trigger(["cityValid", "stateValid"]);
    }
  }, [presentCity, presentState]);

  useEffect(() => {
    if (permaCity || permaState) {
      setValue("permaCityValid", permaCity, { shouldValidate: true });

      trigger(["permaCityValid", "permaStateValid"]);
    }
  }, [permaCity, permaState]);
  

  return (
    <div className="row border-parent accordian-section-wrapper">
      <form className="individual-form" onSubmit={handleSubmit(finalSubmit)}>
        
        <div className="wrap-fields">
          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Father’s Name"
              name="fNameValid"
              placeholder="Enter your father’s name"
              required
              register={register}
              max={40}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value;
                input = input
                  .toUpperCase()
                  .replace(/[^A-Z\s]/g, "")
                  .replace(/\s+/g, " ")
                  .trimStart()
                  .slice(0, 40);

                e.target.value = input;

                e.target.setSelectionRange(start, end);
              }}
              onPaste={handlePasteInput("fNameValid")}
              value={resumeVal?.personalDetails?.fatherName}
            />
            <p className="forget-link add-error">
              <span>{errors?.fNameValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Gender"
              name="genderValid"
              options={genderOptions}
              required
              register={register}
              value={getValues("genderValid")}
            />
            <p className="forget-link add-error">
              <span>{errors?.genderValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Marital Status"
              name="marritalStatValid"
              options={maritalOptions}
              required
              register={register}
              value={getValues("marritalStatValid")}
            />
            <p className="forget-link add-error">
              <span>{errors?.marritalStatValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Income Range"
              name="incomeRange"
              options={masterValue?.incomeRange}
              required
              register={register}
              onKeyPress={(e) => {
                if (!/^[A-Za-z\s]$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              value={getValues("incomeRange")}
              //   value={resumeVal?.incomeRange}
            />
            <p className="forget-link add-error">
              <span>{errors?.incomeRange?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Occupation"
              name="occupationValid"
              options={masterValue?.occupation}
              required
              register={register}
              value={getValues("occupationValid")}
              //   value={resumeVal?.occupation}
            />
            <p className="forget-link add-error">
              <span>{errors?.occupationValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Business Type"
              name="bussinessTypeVal"
              options={masterValue?.natureOfBusiness}
              required
              register={register}
              value={getValues("bussinessTypeVal")}
              //   value={resumeVal?.bussinessType}
            />
            <p className="forget-link add-error">
              <span>{errors?.bussinessTypeVal?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Opt for DDPI"
              name="ddpiValid"
              options={defaultOptions}
              required
              register={register}
              value={getValues("ddpiValid")}

              //   value={resumeVal?.optForDDPI}
            />
            <p className="forget-link add-error">
              <span>{errors?.ddpiValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Activate F&O"
              name="fnoValid"
              options={defaultOptions}
              required
              register={register}
              value={getValues("fnoValid")}

              //   value={resumeVal?.activateFNO}
            />
            <p className="forget-link add-error">
              <span>{errors?.fnoValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Nationality"
              name="nationality"
              required
              register={register}
              valueCheck="INDIAN"
              disable="true"
              // max={25}
              // onChange={(e) => {
              //   const start = e.target.selectionStart;
              //   const end = e.target.selectionEnd;

              //   let input = e.target.value;
              //   input = input
              //     .toUpperCase()
              //     .replace(/[^A-Z\s]/g, "")
              //     .replace(/\s+/g, " ")
              //     .trimStart()
              //     .slice(0, 40);
              //     e.target.value = input;
              //     e.target.setSelectionRange(start, end);
              // }}
              // onPaste={handlePasteNational("nationality")}
              // value={resumeVal?.personalDetails?.nationality}
            />
            <p className="forget-link add-error">
              <span>{errors?.nationality?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Residential Status"
              name="residenAdd"
              required
              register={register}
              valueCheck="INDIAN"
              disable="true"
            />
            <p className="forget-link add-error">
              <span>{errors?.residenAdd?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Type of Account"
              name="accType"
              options={masterValue?.typeOfAcc}
              required
              register={register}
              value={getValues("accType")}

              //   value={resumeVal?.typeOfAccount}
            />
            <p className="forget-link add-error">
              <span>{errors?.accType?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Trading Preferences"
              name="tradingPref"
              options={masterValue?.tradingPreference}
              required
              register={register}
              value={getValues("tradingPref")}

              //   value={resumeVal?.tradingPreferences}
            />
            <p className="forget-link add-error">
              <span>{errors?.tradingPref?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Present Address Line 1"
              name="presentAdd"
              placeholder="Enter address details"
              required
              register={register}
              max={50}
              onPaste={handlePasteAddress("presentAdd")}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value.toUpperCase();
                input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                        input = input.replace(/\s{2,}/g, " "); 
                        input = input.replace(/^\s+/, ""); 

                if (input.length > 50) input = input.slice(0, 50);
                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
              value={resumeVal?.personalDetails?.presentAddressLine1}
            />
            <p className="forget-link add-error">
              <span>{errors?.presentAdd?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Present Address Line 2"
              name="presentAdd2"
              placeholder="Enter address details"
              register={register}
              max={50}
              onPaste={handlePasteAddress("presentAdd2")}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value.toUpperCase();
                input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                        input = input.replace(/\s{2,}/g, " "); 
                        input = input.replace(/^\s+/, ""); 

                if (input.length > 50) input = input.slice(0, 50);
                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
              value={resumeVal?.personalDetails?.presentAddressLine2}
            />
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Pincode"
              name="pinCodeValid"
              placeholder="Enter pincode"
              required
              max={6}
              register={register}
              onPaste={handlePastePincode("pinCodeValid")}
              onChange={(e) => handlePincodeChange(e, "present")}
              onInput={onlyNumber}
              value={
                pincodeVal?.length === 6
                  ? pincodeVal
                  : getValues("pinCodeValid")
              }
            />
            <p className="forget-link add-error">
              <span>{errors?.pinCodeValid?.message}</span>
            </p>
          </div>

          {console.log(presentCity, presentState, getValues("cityValid"), 
          getValues("stateValid"),cityOptions, "cityStateCheck")}
          
          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="City"
              name="cityValid"
              required
              register={register}
              value={
                presentCity?.length > 0 ? presentCity : getValues("cityValid")
              }
              options={
                cityOptions?.length > 0
                  ? cityOptions.map((city) => ({
                      name: city?.city,
                    }))
                  : [
                      {
                        name:
                          presentCity?.length > 0
                            ? presentCity
                            : getValues("cityValid"),
                      },
                    ]
              }
              onChange={(e) => {
                const selected = e.target.value;
                setValue("cityValid", selected, { shouldValidate: true });
                setPresentCity(selected);
              }}
              // getValues={
              //   presentCity?.length > 0 ? presentCity : getValues("cityValid")
              // }
            />
            <p className="forget-link add-error">
              <span>{errors?.cityValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="State"
              name="stateValid"
              required
              register={register}
              value={
                presentState?.length > 0
                  ? presentState
                  : getValues("stateValid")
              }
              options={[
                {
                  name:
                    presentState?.length > 0
                      ? presentState
                      : getValues("stateValid"),
                },
              ]}
              getValues={
                presentState?.length > 0
                  ? presentState
                  : getValues("stateValid")
              }
            />
            <p className="forget-link add-error">
              <span>{errors?.stateValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Permanent Address"
              name="permanentAdd"
              options={permanentAddress}
              required
              register={register}
              value={getValues("permanentAdd")}

              // value={resumeVal?.personalDetails?.permanentAdd}
            />
            <p className="forget-link add-error">
              <span>{errors?.permanentAdd?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Permanent Address Line 1"
              name="permanAdd1"
              placeholder="Enter address details"
              required
              max={50}
              onPaste={handlePasteAddress("permanAdd1")}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value.toUpperCase();
                input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                        input = input.replace(/\s{2,}/g, " "); 
                        input = input.replace(/^\s+/, ""); 

                if (input.length > 50) input = input.slice(0, 50);
                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
              register={register}
              value={resumeVal?.personalDetails?.permanentAddressLine1}
              disable={permanentAdd === "Same as Present Address"}
            />
            <p className="forget-link add-error">
              <span>{errors?.permanAdd1?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Permanent Address Line 2"
              name="permanAdd2"
              placeholder="Enter address details"
              onPaste={handlePasteAddress("permanAdd2")}
              max={50}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value.toUpperCase();
                input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                        input = input.replace(/\s{2,}/g, " "); 
                        input = input.replace(/^\s+/, ""); 

                if (input.length > 50) input = input.slice(0, 50);
                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
              register={register}
              value={resumeVal?.personalDetails?.permanentAddressLine2}
              disable={permanentAdd === "Same as Present Address"}
            />
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Pincode"
              name="permaPinCodeValid"
              placeholder="Enter pincode"
              required
              onPaste={handlePastePincode("permaPinCodeValid")}
              max={6}
              onInput={onlyNumber}
              register={register}
              onChange={(e) => handlePincodeChange(e, "permanent")}
              value={
                permaPincodeVal?.length === 6
                  ? permaPincodeVal
                  : getValues("permaPinCodeValid")
              }
              disable={permanentAdd === "Same as Present Address"}
            />
            <p className="forget-link add-error">
              <span>{errors?.permaPinCodeValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="City"
              name="permaCityValid"
              required
              register={register}
              value={
                permaCity?.length > 0 ? permaCity : getValues("permaCityValid")
              }
              options={
                permaCityOptions?.length > 0
                  ? permaCityOptions.map((city) => ({
                      name: city?.city,
                    }))
                  : [
                      {
                        name:
                          permaCity?.length > 0
                            ? permaCity
                            : getValues("permaCityValid"),
                      },
                    ]
              }
              onChange={(e) => {
                const selected = e.target.value;
                setValue("permaCityValid", selected, { shouldValidate: true });
                setPermaCity(selected);
              }}
              getValues={permanentAdd === "Same as Present Address"}
              // disable={permaCityOptions?.length === 0 || permanentAdd === "Same as Present Address"}
            />
            <p className="forget-link add-error">
              <span>{errors?.permaCityValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="State"
              name="permaStateValid"
              required
              register={register}
              value={
                permaState?.length > 0
                  ? permaState
                  : getValues("permaStateValid")
              }
              options={[
                {
                  name:
                    permaState?.length > 0
                      ? permaState
                      : getValues("permaStateValid"),
                },
              ]}
              getValues={
                permaState?.length > 0
                  ? permaState
                  : getValues("permaStateValid")
              }
              disable={permanentAdd === "Same as Present Address"}
            />
            <p className="forget-link add-error">
              <span>{errors?.permaStateValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Add Nominee Details"
              name="nomineeDetails"
              options={defaultOptions}
              required
              register={register}
              value={getValues("nomineeDetails")}

              //   value={resumeVal?.personalDetails?.addNomineeDetails}
            />
            <p className="forget-link add-error">
              <span>{errors?.nomineeDetails?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Net Worth"
              subLabel="(Older than 1 year as on date)"
              name="netWorth"
              required
              register={register}
              value="0"
              disable="true"
            />
            <p className="forget-link add-error">
              <span>{errors?.netWorth?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Trading Experience"
              name="tradingExper"
              options={masterValue?.tradingExp}
              required
              register={register}
              value={getValues("tradingExper")}

              //   value={resumeVal?.tradingExperience}
            />
            <p className="forget-link add-error">
              <span>{errors?.tradingExper?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Are you Politically Exposed Person?"
              name="politicallyExpo"
              options={politicallyExposed}
              required
              register={register}
              value={getValues("politicallyExpo")}

              //   value={resumeVal?.isPoliticallyExposed}
            />
            <p className="forget-link add-error">
              <span>{errors?.politicallyExpo?.message}</span>
            </p>
          </div>

          {/* <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Past Actions"
              name="pastActions"
              options={pastActions}
              required
              register={register}
              
            />
            <p className="forget-link add-error">
              <span>{errors?.pastActions?.message}</span>
            </p>
          </div> */}

          <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
            <CommonInput
              label="Past Actions"
              name="pastActions"
              required
              register={register}
              value="No"
              disable="true"
            />
            <p className="forget-link add-error">
              <span>{errors?.pastActions?.message}</span>
            </p>
          </div>

          </div>

          <div className="wrap-button">
            <button
              type="submit"
              className="val-btn-wrap"
              // className={`val-btn-wrap ${
              //   !isDirty || !isValid || isDetailsSaved
              //     ? "val-btn-wrap disable-btn"
              //     : ""
              // }`}
              // disabled={!isDirty || !isValid || isDetailsSaved}
            >
              {loader ? (
                <div className="loader-alignment">
                  <SmallLoader />
                </div>
              ) : (
                <>Save</>
              )}
            </button>
          </div>
      </form>
    </div>
  );
}

export default PersonalDetails;
